import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-spremiste-zaglavlje',
  templateUrl: './spremiste-zaglavlje.component.html',
  styleUrls: ['./spremiste-zaglavlje.component.scss']
})
export class ZaglavljeComponent {
  @Input()
  parentArchiveName: any;

  @Input()
  parentObjectName: any;

  @Input()
  parentObjectAdress: any;

  @Input()
  parentObjectArea: any;

  @Input()
  parentProstorijaName: any;

  @Input()
  parentProstorijaArea: any;

  @Input()
  parentSpremisnaJedinicaName: any;

  @Input()
  lokacijaName: any;
}
